import { render } from "./m-dragon-tiger-bet-view.vue?vue&type=template&id=163f1a5a&scoped=true&ts=true"
import script from "./m-dragon-tiger-bet-view.vue?vue&type=script&lang=ts"
export * from "./m-dragon-tiger-bet-view.vue?vue&type=script&lang=ts"

import "./m-dragon-tiger-bet-view.vue?vue&type=style&index=0&id=163f1a5a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163f1a5a"]])

export default __exports__